export default "__VITE_ASSET__DUfdKRbu__"